// Publication facts confirmed by the site administrator, 24 October 2026.
export const publication = {
  name: 'The Standard Newspaper',
  company: 'XL Standard Co. Ltd.',
  established: '2010',
  address: 'Kairaba Avenue, Fajara, The Gambia',
  leadership: [
    { name: 'Sheriff Bojang', role: 'Managing Director & Managing Editor' },
    { name: 'Pa Salla Jeng', role: 'General Manager' },
  ],
};
